/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
/* eslint-disable no-bitwise */
/* eslint-disable no-mixed-operators */
import {
  FormHelperText,
  Card,
  CardContent,
  CardHeader,
  Grid,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  TextField,
  Button,
  List,
  ListItem,
  MenuItem,
  Link,
  Box,
  InputAdornment,
  createFilterOptions,
  Checkbox,
  // Chip
} from '@material-ui/core';
import { PostAdd, Save, Search } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { Formik } from 'formik';
import React, { useEffect, useState, useRef } from 'react';
import { siteOptionKeys } from '../../../constants';
import helpers from '../../../utils/helpers';
import * as yup from 'yup';
import CreateActivityAreaDialog from '../CreateActivityAreaDialog';
import commonService from '../../../services/commonService';
import toast from 'react-hot-toast';
import OptionableAlert from '../OptionableAlert';
import userService from '../../../services/userService';
import { activityAreaUsingType } from '../../../utils/constants';
import ProgressBar from '../ProgressBar';

const filter = createFilterOptions();

// eslint-disable-next-line no-unused-vars
function getRandomColor(name) {
  // get first alphabet in upper case
  const firstAlphabet = name.charAt(0).toLowerCase();

  // get the ASCII code of the character
  const asciiCode = firstAlphabet.charCodeAt(0);

  // number that contains 3 times ASCII value of character -- unique for every alphabet
  const colorNum = asciiCode.toString() + asciiCode.toString() + asciiCode.toString();

  const num = Math.round(0xffffff * parseInt(colorNum, 10));
  const r = num >> 16 & 255;
  const g = num >> 8 & 255;
  const b = num & 255;

  return `rgb(${r}, ${g}, ${b}, 0.3)`;
}

export const RenderHelperText = () => {
  const textModel = [
    'Örn. Makine İmalatçısı,',
    'Örn. Hastane,',
    'Örn. Unlu Mamül İmalatçısı,',
    'Örn. Restaurant İşletmesi,',
    'Örn. Hırdavat,',
    'Örn. Plastik Hammadde Satıcısı,'
  ];

  return (
    <List
      disablePadding
      className="tp-filter-helper_text"
    >
      {
        textModel.map((item) => (
          <ListItem
            key={item}
            sx={{ p: 'unset' }}
          >
            {item}
          </ListItem>
        ))
      }
    </List>
  );
};

const AccountSectorsV2 = () => {
  const [sectors, setSectors] = useState([]);
  const [newActivityAreaName, setActivityAreaName] = useState(null);
  const [profile, setProfile] = useState(null);
  const [companySectorIdModel, setCompanySectorIdModel] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const formRef = useRef();

  // const searchProduct = (key) => {
  //   setLoadingProduct(true);
  //   commonService.getProductByKey(key).then((response) => {
  //     if (response) {
  //       setProducts(response);
  //     }
  //     setLoadingProduct(false);
  //   });
  // };

  const onSave = async (values, { setSubmitting }) => {
    const formData = new FormData();
    formData.append('companyName', values.companyName);
    formData.append('companyLegalName', values.companyLegalName);
    formData.append('about', values.about);
    formData.append('vkn', values.vkn);
    formData.append('tckn', values.tckn);
    formData.append('giro', values.giro);
    formData.append('employeeCount', values.employeeCount);
    formData.append('website', values.website);
    formData.append('taxOffice', values.taxOffice);
    formData.append('additionalnformations', values.additionalnformations);
    if (Array.isArray(values.sectorId)) {
      values.sectorId.forEach((sector) => {
        formData.append('sectorId', sector.id);
      });
    }
    if (Array.isArray(values.selectedAddresses)) {
      values.selectedAddresses.forEach((f) => {
        formData.append('selectedAddresses', f);
      });
    }
    if (values.companyBeginDate) {
      let parsedDate = Date.parse(values.companyBeginDate);
      if (parsedDate) {
        parsedDate = new Date(values.companyBeginDate);
        formData.append('companyBeginDate', parsedDate.toUTCString());
      }
    }

    formData.append('companyType', values.companyType);
    formData.append('keywords', values.keywords);
    values.companySectorId.forEach((m) => {
      formData.append('companySectorId', m.id);
    });

    const success = () => {
      setSubmitting(false);
      toast.success('Başarıyla güncellendi');
    };

    const error = (err) => {
      setSubmitting(false);
      toast.error('Bir hata oluştu');
    };

    userService.updateProfile(formData, success, error);
  };

  const onClikNewItem = (name) => {
    setActivityAreaName(name);
  };

  const handleNewActivityArea = (values) => {
    commonService.addSector(values)
      .then((response) => {
        if (response) {
          const selectedItem = { name: values.name, id: response };
          setSectors((prev) => [...prev, selectedItem]);
          formRef.current.setFieldValue('companySectorId', selectedItem);
          toast.success('Faaliyet alanı ekleme talebiniz alınmıştır.');
        }
      });
    setActivityAreaName(null);
  };

  useEffect(async () => {
    const getSectors = async () => {
      const sec = await helpers.getSectors();
      setSectors(sec);
    };

    const getProfile = () => {
      setIsLoading(true);
      userService.getSellerProfile()
        .then((response) => {
          if (response) {
            setProfile(response);
          }
        }).finally(() => {
          setIsLoading(false);
        });
    };
    await getSectors();
    getProfile();
  }, []);

  useEffect(() => {
    if (profile?.companySectorId && Array.isArray(sectors)) {
      const companySectorId = sectors.filter((sec) => profile.companySectorId.includes(sec.id));
      setCompanySectorIdModel(companySectorId);
    }
  }, [sectors, profile]);

  return (
    <>
      <Card>
        <CardHeader title="Faaliyet Alanlarım" />
        <CardContent
          sx={{
            px: 8,
            py: 2,
          }}
        >
          <Formik
            initialValues={{
              companyType: 'both',
              keywords: '',
              ...(profile || {}),
              companySectorId: companySectorIdModel,
            }}
            onSubmit={onSave}
            validationSchema={yup.object().shape({
              companyType: yup.string().nullable().required('zorunlu'),
              keywords: yup.string().nullable(),
              companySectorId: yup.array().nullable().required('zorunlu'),
            })}
            innerRef={formRef}
            enableReinitialize
          >
            {
              (actions) => {
                return (
                  <Grid
                    component="form"
                    onSubmit={actions.handleSubmit}
                    container
                    spacing={2}
                  >
                    {/* <OptionableAlert
                      permanent
                      body={(
                        <Typography
                          variant="body1"
                          fontWeight={500}
                        >
                          Tedarikçi – Satıcı firmaların Platformda oluşturulmuş Satın Alma taleplerine- ihalelerine
                          {' '}
                          <strong>teklif verebilmeleri </strong>
                          {' '}
                          için aşağıda bulunan maddelerden
                          {' '}
                          <strong>2. veya 3. Maddelerden birini</strong>
                          {' '}
                          işaretlemesi ve
                          {' '}
                          <strong>Faaliyet Alanlarını</strong>
                          {' '}
                          yazması gerekmektedir
                        </Typography>
                      )}
                      name={siteOptionKeys.doNotShowActivityAreaWarning}
                      title="Önemli!"
                    /> */}
                    {
                      isLoading ? (
                        <ProgressBar />
                      ) : (
                        <>
                          {/* <Grid
                            item
                            xs={12}
                          >
                            <FormControl
                              error={Boolean(actions.touched.companyType && actions.errors.companyType)}
                            >
                              <FormLabel>Kullanım Şekliniz</FormLabel>
                              <RadioGroup
                                name="companyType"
                                onChange={actions.handleChange}
                                value={actions.values.companyType}
                              >
                                <FormControlLabel
                                  value={activityAreaUsingType.buy.name}
                                  control={<Radio />}
                                  label={activityAreaUsingType.buy.label}
                                />
                                <FormControlLabel
                                  value={activityAreaUsingType.sell.name}
                                  control={<Radio />}
                                  label={activityAreaUsingType.sell.label}
                                />
                                <FormControlLabel
                                  value={activityAreaUsingType.both.name}
                                  control={<Radio />}
                                  label={activityAreaUsingType.both.label}
                                />
                              </RadioGroup>
                              {
                                Boolean(actions.touched.companyType && actions.errors.companyType) && (
                                  <FormHelperText>{actions.errors.companyType}</FormHelperText>
                                )
                              }
                            </FormControl>
                          </Grid> */}
                          <Grid
                            item
                            xs={12}
                          >
                            <FormControlLabel
                              control={(
                                <Checkbox
                                  checked={actions.values.companyType}
                                  onChange={actions.handleChange}
                                  name="companyType"
                                  size="small"
                                />
                              )}
                              label={activityAreaUsingType.sell.label}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                          >
                            <Autocomplete
                              value={actions.values.companySectorId}
                              onChange={(event, newValue) => {
                                if (typeof newValue === 'string') {
                                  actions.setFieldValue('companySectorId', { name: newValue });
                                } else {
                                  actions.setFieldValue('companySectorId', newValue);
                                }
                              }}
                              options={sectors}
                              getOptionLabel={(option) => {
                                // Value selected with enter, right from the input
                                if (typeof option === 'string') {
                                  return option;
                                }
                                // Regular option
                                return option.name;
                              }}
                              isOptionEqualToValue={(opt, val) => opt.id === val.id}
                              filterOptions={(options, params) => {
                                const filtered = filter(options, params);
                                const { inputValue } = params;
                                // Suggest the creation of a new value
                                const isExisting = options.some((option) => option.name.toLowerCase().replaceAll(' ', '').includes(inputValue.toLowerCase().replaceAll(' ', '')));
                                if (inputValue !== '' && !isExisting) {
                                  filtered.push({
                                    inputValue,
                                    isNew: true,
                                    name: inputValue,
                                  });
                                }

                                return filtered;
                              }}
                              renderOption={(p, option) => (
                                <MenuItem
                                  {...p}
                                  onClick={!option.isNew ? p.onClick : () => {
                                    onClikNewItem(option.name);
                                  }}
                                >
                                  {!option.isNew && option.name}
                                  {option.isNew && option.name && (
                                    <Box sx={{ display: 'flex', flexFlow: 'row nowrap', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
                                      <PostAdd />
                                      <Typography>
                                        <Link>{option.name}</Link>
                                        {' '}
                                        adında yeni bir faaliyet alanı eklemek için tıklayın
                                      </Typography>
                                    </Box>
                                  )}
                                </MenuItem>
                              )}
                              autoComplete
                              includeInputInList
                              filterSelectedOptions
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Firma Faaliyet Alanı"
                                  // name="companySectorId"
                                  // value={actions.values.companySectorId }
                                  // onChange={actions.handleChange}
                                  fullWidth
                                  multiline
                                  maxRows={3}
                                  sx={{
                                    mr: 5,
                                  }}
                                  error={Boolean(actions.touched.companySectorId && actions.errors.companySectorId)}
                                  helperText={actions.touched.companySectorId && actions.errors.companySectorId
                                    ? actions.errors.companySectorId : (
                                      <RenderHelperText />
                                    )}
                                // InputProps={{
                                //   ...params.InputProps,
                                //   startAdornment: (
                                //     <InputAdornment position="start">
                                //       <Search fontSize="small" />
                                //     </InputAdornment>
                                //   )
                                // }}
                                />
                              )}
                              multiple
                              disableCloseOnSelect
                            // renderTags={(tagValue, getTagProps) => tagValue.map((option, index) => (
                            //   <Chip
                            //     label={option.name}
                            //     {...getTagProps({ index })}
                            //     sx={{
                            //       backgroundColor: getRandomColor(option.name),
                            //     }}
                            //   />
                            // ))}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                          >
                            <Grid container>
                              <Grid
                                item
                                xs={12}
                              >
                                {/* <Autocomplete
                    multiple
                    options={products}
                    value={actions.values.keywords }
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                        actions.setFieldValue('keywords ', [...actions.values.keywords , { name: newValue }]);
                      } else {
                        const filteredValues = newValue.filter((item, index) => {
                          const duplicate = newValue.find((item2, index2) => index2 !== index && item2.id === item.id);
                          return !duplicate;
                        });
                        actions.setFieldValue('keywords ', filteredValues);
                      }
                      // setValue([
                      //   ...fixedOptions,
                      //   ...newValue.filter((option) => fixedOptions.indexOf(option) === -1),
                      // ]);
                    }}
                    renderTags={(tagValue, getTagProps) => tagValue.map((option, index) => (
                      <Chip
                        label={option.name}
                        {...getTagProps({ index })}
                        sx={{
                          backgroundColor: getRandomColor(option.name),
                        }}
                      />
                    ))}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Firmanıza ait Ürünler/Hizmetler için anahtar kelime giriniz"
                        placeholder={actions.values.keywords .length < 1 ? 'Rulman, Kasnak, Elektrik Malzemesi, Giyim, Gıda, Tıbbi Ekipman' : ''}
                        multiline
                        fullWidth
                        minRows={3}
                        maxRows={5}
                        error={Boolean(actions.touched.keywords  && actions.errors.keywords )}
                        helperText={actions.touched.keywords  && actions.errors.keywords }
                      />
                    )}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === 'string') {
                        return option;
                      }
                      // Regular option
                      return option.name;
                    }}
                    inputValue={searchValue}
                    onInputChange={(event) => {
                      if (!event) {
                        setSearchValue('');
                        return;
                      }
                      setSearchValue(event.target.value);
                    }}
                    loading={loadingProduct}
                    freeSolo
                    popupIcon={null}
                  /> */}
                                <TextField
                                  name="keywords"
                                  value={actions.values.keywords || ''}
                                  onChange={actions.handleChange}
                                  label="Firmanıza ait Ürünler/Hizmetler için anahtar kelime giriniz"
                                  placeholder={actions.values.keywords?.length < 1 ? 'Rulman, Kasnak, Elektrik Malzemesi, Giyim, Gıda, Tıbbi Ekipman' : ''}
                                  multiline
                                  fullWidth
                                  minRows={3}
                                  maxRows={5}
                                  error={Boolean(actions.touched.keywords && actions.errors.keywords)}
                                  helperText={actions.touched.keywords && actions.errors.keywords}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            textAlign="center"
                            sx={{
                              mt: 2,
                            }}
                          >
                            <Button
                              variant="contained"
                              color="primary"
                              startIcon={<Save />}
                              type="submit"
                              disabled={actions.isSubmitting}
                            >
                              Kaydet
                            </Button>
                          </Grid>
                        </>
                      )
                    }

                  </Grid>
                );
              }
            }
          </Formik>
        </CardContent>
      </Card>
      <CreateActivityAreaDialog
        initialValue={newActivityAreaName}
        handleCreate={handleNewActivityArea}
        onClose={() => { setActivityAreaName(null); }}
        open={!!newActivityAreaName}
      />
    </>
  );
};

export default AccountSectorsV2;

AccountSectorsV2.propTypes = {
};
